import Vue from "vue";
import Component from "vue-class-component";
import REQ_URL from "@/consts/req-url";
import Slider from "@/components/Slider/Slider";
import SliderElement from "@/components/Slider/SliderElement";
import { Model, Prop, Watch } from "vue-property-decorator";
import { register } from "register-service-worker";
import { Getter } from "vuex-class";
import { Client, Manager, Profile, ProfileType } from "@/api/profile";
import FormResStatus from "@/api/form-res-status";
import { required, email } from "vuelidate/lib/validators";
import { ResData } from "@/types/response-data";

@Component({
  components: {
    Slider,
    SliderElement,
  },
  validations: {
    formData: {
      email: { required, email },
    }
  },
})
export default class AdvanceInvoice extends Vue {
  @Model("change", { default: false }) open!: boolean;
  @Prop({ required: true }) data!: {
    basket: any;
    type: string;
    delivery: boolean;
    settlementAccount: any;
    contractor: string;
  };

  @Getter("managerInfo") managerInfo!: Manager;
  @Getter("clientProfile") clientProfile!: Client;
  @Getter("profile") profile!: Profile<ProfileType>;
  @Getter("profileType") profileType!: ProfileType;

  formStatus = new FormResStatus();
  formData = {
    email: ""
  }

  type: "default" | "client" | "custom" = "default";

  mounted() {
    this.formData.email = this.profile.email;
  }

  @Watch("type") onTypeChange() {
    if (this.type === "client") this.formData.email = this.clientProfile.email;
    else if (this.type === "default") this.formData.email = this.profile.email;
    else this.formData.email = "";
  }

  close() {
    this.$emit("update:open", false);
  }

  async submit() {
    this.$v.$touch();

    if (this.$v.$error) return;
    
    try {
      let data = await this.$fetch<ResData<any>>(
        REQ_URL.SEND_AI_EMAIL,
        {
          method: "POST",
          body: JSON.stringify({
            form: this.formData,
            data: this.data,
          }),
          credentials: "same-origin",
        },
        this.formStatus
      );

      if (data.msg) {
        this.$emit("update:open", false);
        this.$v.$reset();
        this.formStatus.reset();
        this.$store.commit("modal:open", {
          type: "success",
          msg: data.msg,
        });
      } else throw new Error(data.error);
    } catch (error) {
      console.error(error.message);
      if (error.code === 901) {
        this.$emit("update:open", false);
        this.$v.$reset();
        this.formStatus.reset();
        this.$store.commit("modal:open", {
          type: "warning",
          msg: error.message,
        });
      }
    }

    this.close();
  }
}
